import { RefObject, useCallback, useEffect, useState } from 'react';

import ResizeObserver from 'resize-observer-polyfill';

export const useResizeObserver = (
  ref: RefObject<HTMLElement>,
  callback?: (entry: ResizeObserverEntry) => void
): [number, number] => {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);

  const onResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      const entry = entries[0];
      setWidth(entry.contentRect.width);
      setHeight(entry.contentRect.height);

      if (callback) {
        callback(entry);
      }
    },
    [callback]
  );

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) =>
      onResize(entries)
    );
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, ref?.current]);

  return [width, height];
};
